import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DocumentInput } from 'src/app/shared/models';
import { Mail } from 'src/app/shared/models/mails/mail';
import { MailInsert } from 'src/app/shared/models/iCourrier/post/mail-insert';
import { FilesService } from 'src/app/shared/services/files.service';
import * as _ from 'underscore';
import { v4 as uuidv4 } from 'uuid';
@Component({
  selector: 'app-c-mode-choice-modal',
  templateUrl: './c-mode-choice-modal.component.html',
  styleUrls: ['./c-mode-choice-modal.component.scss'],
})
export class CModeChoiceModalComponent implements OnInit {
  public mailId: number;
  public mail: Mail;
  public mailAnswer: MailInsert;
  public modeAnswer: boolean;
  public newMail: Mail;
  public showOnlyEmailOption = false;

  constructor(
    public router: Router,
    public spinner: NgxSpinnerService,
    public toastr: ToastrService,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private filesService: FilesService
  ) {}

  ngOnInit(): void {
    if (this.config && this.config.data) {
      this.mailId = this.config.data.mailId;
      this.mail = this.config.data.mail;
      this.newMail = this.config.data.newMail;
      this.modeAnswer = this.config.data.modeAnswer;
      this.showOnlyEmailOption = this.config.data.showOnlyEmailOption;
    }
  }

  public close(): void {
    this.ref.close();
  }

  public saveAnswer(): void {
    this.mailAnswer = new MailInsert({
      dateEntree: new Date(),
      dateDocument: this.mail.dateEntree,
      serviceProprietaireId: this.mail.serviceProprietaireId,
      refExpediteur: 'réponse ' + this.mail.title,
    });
    sessionStorage.setItem('newCourrier', JSON.stringify(this.mailAnswer));
    sessionStorage.setItem('answerDest', (this.mail.expediteurIdiAdmin ?? this.mail.expediteurId).toString());
  }

  openFile(): void {
    document.getElementsByClassName('fileUploadCustom')[0].querySelector('input').click();
  }

  addDocument(file, pFileUpload): void {
    let uploaded = null;

    if (file && file.currentFiles.length > 0) {
      uploaded = _.first(file.currentFiles);
    }

    this.spinner.show();
    const docInput: DocumentInput = new DocumentInput({
      pdfFileRequired: true,
      file: new Blob([uploaded], { type: 'application/rtf' }),
      description: uploaded.name,
      guid: uuidv4(),
      version: 1,
    });
    Object.keys(docInput).forEach((key) => docInput[key] == null && delete docInput[key]);

    this.filesService.addDocument(this.mailId, docInput, false, false, []).subscribe({
      next: () => {
        this.toastr.success('Merci', 'Votre document a été créé!');
        this.close();
        pFileUpload.clear();
        this.spinner.hide();
      },
      error: (error) => {
        console.error('Error : ', error);
        this.toastr.error("Une erreur est survenue lors de l'envoi du formulaire");
        this.spinner.hide();
      },
    });
  }
}
